/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type userMessageMutationVariables = {||};
export type userMessageMutationResponse = {|
  +corpoSendValidEmail: ?{|
    +code: number,
    +success: boolean,
    +message: string,
  |}
|};
export type userMessageMutation = {|
  variables: userMessageMutationVariables,
  response: userMessageMutationResponse,
|};
*/


/*
mutation userMessageMutation {
  corpoSendValidEmail {
    code
    success
    message
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "CorpoMutationPayload",
    "kind": "LinkedField",
    "name": "corpoSendValidEmail",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "code",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "success",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "message",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "userMessageMutation",
    "selections": (v0/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "userMessageMutation",
    "selections": (v0/*: any*/)
  },
  "params": {
    "cacheID": "3b5dfd056bb98a44eddc2bda3d213fe5",
    "id": null,
    "metadata": {},
    "name": "userMessageMutation",
    "operationKind": "mutation",
    "text": "mutation userMessageMutation {\n  corpoSendValidEmail {\n    code\n    success\n    message\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'e9530313bf05e63bcebbcd6cd9a3530e';

module.exports = node;
